import { useEffect, useContext } from "react";
import { SignalRContext } from "us.common/SignalRProvider";

type Trigger = {
  name: string;
  callBack: (...args: any[]) => void;
};

export const useSignalRTriggers = (triggers: Trigger[]) => {
  const { connection } = useContext(SignalRContext);

  useEffect(() => {
    if (!connection || !triggers?.length) return;

    triggers.forEach(({ name, callBack }) => {
      console.log(`🟢 Registering: ${name}`);
      connection.on(name, callBack);
    });

    return () => {
      triggers.forEach(({ name, callBack }) => {
        console.log(`🔴 Removing: ${name}`);
        connection.off(name, callBack);
      });
    };
  }, [connection, triggers]);
};
